<div class="eq-and-conn-details-container">

    <div class="new-section">

        <div class="eq-conn-title">AC Line Segment <span
                class="specific-eq-conn-count">({{acLineSegments.length}})</span></div>

        <button *ngIf="selectedAcLineType.type == 'Outgoing'" (click)="newLine()" data-bs-toggle="modal"
            data-bs-target="#editAddModal-1">
            <svg width="17" height="17" viewBox="0 0 17 17" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M3.59277 0.375H12.9072C13.4021 0.374991 13.7932 0.375641 14.1084 0.401367C14.4332 0.427902 14.7056 0.482413 14.9531 0.608398C15.3569 0.814124 15.6858 1.14308 15.8916 1.54688C16.0176 1.79432 16.072 2.06678 16.0986 2.3916C16.1243 2.70679 16.125 3.09795 16.125 3.59277V12.9072C16.125 13.402 16.1243 13.7931 16.0986 14.1084C16.072 14.4332 16.0176 14.7056 15.8916 14.9531C15.6858 15.3569 15.3569 15.6858 14.9531 15.8916C14.7056 16.0176 14.4332 16.072 14.1084 16.0986C13.7931 16.1243 13.402 16.125 12.9072 16.125H3.59277C3.09795 16.125 2.70679 16.1243 2.3916 16.0986C2.06678 16.072 1.79432 16.0176 1.54688 15.8916C1.14309 15.6858 0.815101 15.3568 0.609375 14.9531C0.483247 14.7055 0.427916 14.4333 0.401367 14.1084C0.375639 13.7932 0.374991 13.4021 0.375 12.9072V3.59277C0.374991 3.09791 0.375638 2.70675 0.401367 2.3916C0.427905 2.06683 0.482411 1.79431 0.608398 1.54688C0.814135 1.1431 1.1431 0.814135 1.54688 0.608398C1.79431 0.482411 2.06683 0.427905 2.3916 0.401367C2.70675 0.375638 3.09791 0.374991 3.59277 0.375ZM8.25 4.21484C7.66337 4.21484 7.18774 4.69073 7.1875 5.27734V7.1875H5.27734C4.6907 7.18763 4.21494 7.66338 4.21484 8.25C4.21484 8.8367 4.69064 9.31237 5.27734 9.3125H7.1875V11.2227C7.1875 11.8094 7.66321 12.2852 8.25 12.2852C8.83679 12.2852 9.3125 11.8094 9.3125 11.2227V9.3125H11.2295C11.8161 9.31232 12.292 8.83668 12.292 8.25C12.2919 7.6634 11.8161 7.18768 11.2295 7.1875H9.3125V5.27734C9.31226 4.69073 8.83663 4.21484 8.25 4.21484Z"
                    fill="#171717" stroke="#171717" stroke-width="0.75" />
            </svg>
            <div>New Line</div>
        </button>
        <button *ngIf="selectedAcLineType.type == 'Incoming'" (click)="updateLine()" data-bs-toggle="modal"
            data-bs-target="#acLineAddModal-1">
            <svg width="17" height="17" viewBox="0 0 17 17" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M3.59277 0.375H12.9072C13.4021 0.374991 13.7932 0.375641 14.1084 0.401367C14.4332 0.427902 14.7056 0.482413 14.9531 0.608398C15.3569 0.814124 15.6858 1.14308 15.8916 1.54688C16.0176 1.79432 16.072 2.06678 16.0986 2.3916C16.1243 2.70679 16.125 3.09795 16.125 3.59277V12.9072C16.125 13.402 16.1243 13.7931 16.0986 14.1084C16.072 14.4332 16.0176 14.7056 15.8916 14.9531C15.6858 15.3569 15.3569 15.6858 14.9531 15.8916C14.7056 16.0176 14.4332 16.072 14.1084 16.0986C13.7931 16.1243 13.402 16.125 12.9072 16.125H3.59277C3.09795 16.125 2.70679 16.1243 2.3916 16.0986C2.06678 16.072 1.79432 16.0176 1.54688 15.8916C1.14309 15.6858 0.815101 15.3568 0.609375 14.9531C0.483247 14.7055 0.427916 14.4333 0.401367 14.1084C0.375639 13.7932 0.374991 13.4021 0.375 12.9072V3.59277C0.374991 3.09791 0.375638 2.70675 0.401367 2.3916C0.427905 2.06683 0.482411 1.79431 0.608398 1.54688C0.814135 1.1431 1.1431 0.814135 1.54688 0.608398C1.79431 0.482411 2.06683 0.427905 2.3916 0.401367C2.70675 0.375638 3.09791 0.374991 3.59277 0.375ZM8.25 4.21484C7.66337 4.21484 7.18774 4.69073 7.1875 5.27734V7.1875H5.27734C4.6907 7.18763 4.21494 7.66338 4.21484 8.25C4.21484 8.8367 4.69064 9.31237 5.27734 9.3125H7.1875V11.2227C7.1875 11.8094 7.66321 12.2852 8.25 12.2852C8.83679 12.2852 9.3125 11.8094 9.3125 11.2227V9.3125H11.2295C11.8161 9.31232 12.292 8.83668 12.292 8.25C12.2919 7.6634 11.8161 7.18768 11.2295 7.1875H9.3125V5.27734C9.31226 4.69073 8.83663 4.21484 8.25 4.21484Z"
                    fill="#171717" stroke="#171717" stroke-width="0.75" />
            </svg>
            <div>Update Line</div>
        </button>
    </div>

    <div class="ac-line-type-tabs">
        <button *ngFor="let acLineType of acLineTypes" [class.selected]="selectedAcLineType.id === acLineType.id"
            (click)="switchAcLineType(acLineType)">
            {{ acLineType.name }}
        </button>
    </div>

    <div class="list-item-container">
        <div *ngFor="let acLineSegment of acLineSegmentsFilteredByType" class="list-item"
            [class.open]="isOpen && selectedAcLineSegmentId?.value === acLineSegment.id">

            <div class="list-item-always">
                <div class="d-flex flex-column gap-2">

                    <div>
                        {{ acLineSegment.name | hasValue}}
                    </div>

                    <div class="d-flex gap-2 item-info align-items-center">

                        <div>
                            Number {{ acLineSegment.number | hasValue}}
                        </div>

                        <div class="small-circle"></div>

                        <div>
                            Transformer {{ acLineSegment.powerTransformerName | hasValue}}
                        </div>

                    </div>

                </div>

                <div class="d-flex align-items-center gap-2">
                    <button (click)="selectAcLineSegment(acLineSegment.id)" data-bs-toggle="modal"
                        data-bs-target="#editAddModal-1">
                        <svg width="19" height="19" viewBox="0 0 19 19" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path
                                d="M10.375 3.88644L12.9745 1.28697C13.6904 0.571009 14.8513 0.571009 15.5672 1.28697L17.0995 2.81924C17.8154 3.53521 17.8154 4.69601 17.0995 5.41197L14.5 8.01144M10.375 3.88644L1.28697 12.9745C0.943151 13.3183 0.75 13.7846 0.75 14.2708V17.6364H4.11561C4.60184 17.6364 5.06815 17.4433 5.41197 17.0995L14.5 8.01144M10.375 3.88644L14.5 8.01144"
                                stroke="#171717" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
                        </svg>
                    </button>

                    <button (click)="toggleHiddenInfo(acLineSegment.id)" class="arrow-btn"
                        [class.open]="isOpen && selectedAcLineSegmentId?.value === acLineSegment.id">
                        <svg width="9" height="5" viewBox="0 0 9 5" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path
                                d="M0.752607 0.75L3.44696 3.44436C3.98395 3.98134 4.8546 3.98134 5.39158 3.44436L8.08594 0.75"
                                stroke="#171717" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
                        </svg>
                    </button>
                </div>
            </div>

            <div class="list-item-hidden" [class.open]="isOpen && selectedAcLineSegmentId?.value === acLineSegment.id">
                <div class="inner-container">
                    <div class="section-name pb-3">
                        Asset Details
                    </div>

                    <div class="info-row d-flex justify-content-between align-items-center pb-2">
                        <div>
                            AC Line Name
                        </div>

                        <div>
                            {{ acLineSegment.name | hasValue }}
                        </div>
                    </div>

                    <div class="info-row d-flex justify-content-between align-items-center pb-2">
                        <div>
                            Number
                        </div>

                        <div>
                            {{ acLineSegment.number | hasValue }}
                        </div>
                    </div>

                    <div class="info-row d-flex justify-content-between align-items-center pb-3">
                        <div>
                            Region
                        </div>

                        <div>
                            {{ acLineSegment.region | hasValue }}
                        </div>
                    </div>

                    <div style="width: 100%; height: 1.5px; background-color: #f0f0f0;"></div>

                    <div class="section-name py-3">
                        History
                    </div>

                    <div class="info-row d-flex justify-content-between align-items-center pb-2">
                        <div>
                            Date Created
                        </div>

                        <div>
                            {{ acLineSegment.dateCreated | hasValue | date:'MMMM dd, yyyy'}}
                        </div>
                    </div>

                    <div class="info-row d-flex justify-content-between align-items-center">
                        <div>
                            Last Modified
                        </div>

                        <div>
                            {{ acLineSegment.lastModified | hasValue | timeAgo}}
                        </div>
                    </div>
                </div>
            </div>

        </div>
    </div>

</div>

<lib-nec-add-edit-modal-ac-line-segment [hidden]="!modalOpened" [selectedAcLineSegmentId]="selectedAcLineSegmentId"
    [substationId]="substationId" (acLineSegmentSaved)="reloadList()" [hidden]="!modalOpened"
    [isOpenedFromSubstation]="true">
</lib-nec-add-edit-modal-ac-line-segment>
<lib-nec-add-incomming-line-to-ss-modal (acLineSegmentSaved)="reloadList()" [substationId]="substationId">
</lib-nec-add-incomming-line-to-ss-modal>